/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileImageLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileImageLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 24h28v15.895l-.523-.524-.105-.105c-.87-.872-1.803-1.802-2.721-2.547a6.502 6.502 0 0 0-1.868-1.225 4.644 4.644 0 0 0-1.376-.421 6.5 6.5 0 0 0-5.794 1.788l-4.337 4.34a1.536 1.536 0 0 1-2.12 0l-.757-.76a4.495 4.495 0 0 0-3.965-1.231c-.34.043-.662.149-.955.285a4.511 4.511 0 0 0-.476.236v.021a6.633 6.633 0 0 0-.632.448c-.614.486-1.222 1.107-1.745 1.655l-.291.306-.335.351V24Zm11.177 12.838c-.379.14-.783.195-1.184.162a2.782 2.782 0 0 1-2.998-3 2.787 2.787 0 0 1 2.997-3 2.78 2.78 0 0 1 2.836 1.815c.14.379.195.783.162 1.185a2.785 2.785 0 0 1-1.813 2.838Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M49.395 41.532c.832.835 1.724 1.73 2.605 2.474V52H24v-5.624c.14-.063.261-.131.361-.192.312-.19.606-.433.864-.667.424-.383.886-.87 1.314-1.32a128.553 128.553 0 0 1 .461-.483v.013l.825-.825c.14-.128.276-.245.407-.35.326-.257.502-.333.553-.355l.015-.008a1.499 1.499 0 0 1 1.476.38l.758.76a4.496 4.496 0 0 0 6.359 0l4.34-4.345a3.518 3.518 0 0 1 3.849-.737l.016.007c.265.136.598.35 1.008.67l.07.056.043.043 2.262 2.1v-.005l.414.414Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M52 24H24v1h28v-1ZM33.992 37a2.782 2.782 0 0 0 2.994-2.5c.016.166.018.333.004.5a2.785 2.785 0 0 1-2.998 3 2.782 2.782 0 0 1-2.997-3 2.792 2.792 0 0 1 .004-.5 2.79 2.79 0 0 0 1.809 2.338c.378.14.783.195 1.184.162Zm15.403 4.532-.414-.414v.004l-2.262-2.099-.044-.044-.069-.054a6.496 6.496 0 0 0-1.008-.671l-.016-.007a3.513 3.513 0 0 0-3.85.737l-4.34 4.344a4.494 4.494 0 0 1-6.358 0l-.758-.759a1.498 1.498 0 0 0-1.476-.38l-.015.008c-.051.022-.227.098-.553.356-.131.104-.267.22-.407.349l-.825.825v-.013a57.7 57.7 0 0 0-.46.482c-.429.451-.891.938-1.315 1.321a5.955 5.955 0 0 1-.864.667c-.1.06-.221.13-.361.192v1c.14-.063.261-.131.361-.192.312-.19.606-.433.864-.667.424-.383.886-.87 1.314-1.32a128.553 128.553 0 0 1 .461-.483v.013l.825-.825c.14-.128.276-.245.407-.35.326-.257.502-.333.553-.355l.015-.008a1.499 1.499 0 0 1 1.476.38l.758.76a4.496 4.496 0 0 0 6.359 0l4.34-4.345a3.518 3.518 0 0 1 3.849-.737l.016.007c.265.136.598.35 1.008.67l.07.056.043.043 2.262 2.1v-.005l.414.414c.832.835 1.724 1.73 2.605 2.474v-1c-.88-.745-1.773-1.64-2.605-2.474Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileImageLarge
};
